import reducers from "./EkgListReducers";

export default reducers;
